import { render, staticRenderFns } from "./issueImportFromFriend.vue?vue&type=template&id=790687c7&scoped=true&lang=pug&"
import script from "./issueImportFromFriend.vue?vue&type=script&setup=true&lang=js&"
export * from "./issueImportFromFriend.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./issueImportFromFriend.vue?vue&type=style&index=0&id=790687c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790687c7",
  null
  
)

export default component.exports